
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/stop-motion-machine",
      function () {
        return require("private-next-pages/archive/stop-motion-machine.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/stop-motion-machine"])
      });
    }
  